export default {
    "general": {
        "Save"                        : "Save",
        "Send"                        : "Send",
        "Cancel"                      : "Cancel",
        "istobal-logo"                : "ISTOBAL - Vehicle Wash & Care",
        "logo_istobal"                : "ISTOBAL - Vehicle Wash & Care",
        "Models"                      : "Models",
        "Plain"                       : "Plain",
        "Rocket"                      : "Rocket",
        "Zenit"                       : "Zenit",
        "Cubik"                       : "Cubik",
        "PremiumLed"                  : "Premium Led",
        "PremiumMethacrylate"         : "Premium Methacrylate",
        "Premium"                     : "Premium",
        "Structure"                   : "Structure",
        "estructura"                  : "Structure",
        "Fairing"                     : "Fairing",
        "carenado"                    : "Fairing",
        "Front/rearFairing"           : "Front/rear fairing",
        "cabut"                       : "Front/rear fairings",
        "Front/rearFairings"          : "Front/rear fairings",
        "cabuts"                      : "Front/rear fairings",
        "Door"                        : "Doors",
        "puerta"                      : "Doors",
        "Doors"                       : "Doors",
        "PlainDoor"                   : "Plain door",
        "Led"                         : "Led",
        "WheelWash"                   : "Wheel wash",
        "lavarruedas"                 : "Wheel wash",
        "Light"                       : "Light",
        "luminoso"                    : "Light",
        "luminososuperior"            : "Top light",
        "Luminoso"                    : "Light",
        "Lights"                      : "Lights",
        "TrafficLight"                : "Traffic light",
        "TrafficLightPositioning"     : "Traffic light positioning",
        "Sferic"                      : "Sferic",
        "Boomerang"                   : "Boomerang",
        "Linear"                      : "Linear",
        "Pictogram"                   : "Pictogram",
        "pictograma"                  : "Pictogram",
        "pictogramasuperior"          : "Top pictogram",
        "Pictograms"                  : "Pictograms",
        "PitLane"                     : "Pit Lane",
        "Pictogram2020"               : "Pictograma 2020",
        "Volaverunt"                  : "Volaverunt",
        "VolaveruntBlanco"            : "Volaverunt blanco",
        "VolaveruntNegro"             : "Volaverunt negro",
        "Color"                       : "Color",
        "Silver"                      : "Silver",
        "Hexa"                        : "Hexa",
        "Brushes"                     : "Brushes",
        "basicSelector"               : "Basic",
        "basicSelectorInvert"         : "Advanced",
        "advancedSelector"            : "Advanced",
        "Flat"                        : "Solid",
        "Liso"                        : "Solid",
        "3stripes"                    : "3 stripes",
        "Bandas"                      : "3 stripes",
        "Streaked"                    : "Custom",
        "Rayado"                      : "Custom",
        "CONFIGURATOR"                : "CONFIGURADOR",
        "SelectAnOption"              : "Select one rollover to start configuration",
        "select"                      : "select",
        "ClickSelectColor"            : "Click to select color",
        "ClickSelectColorPatron"      : "Click to place colors",
        "ColorSelector"               : "Color selector",
        "SelectColor"                 : "Select color",
        "Yes"                         : "Yes",
        "No"                          : "No",
        "SaveConfig"                  : "Save config",
        "Share"                       : "Share",
        "ContactUs"                   : "Contact us",
        "ShareContact"                : "Share or save",
        "FrontImage"                  : "Front image",
        "BackImage"                   : "Back image",
        "FrontRender"                 : "Front render",
        "BackRender"                  : "Back render",
        "PrivacyText"                 : " The images, videos and information that appear in this space are illustrative and do not constitute a comercial offer. You can contact ISTOBAL's commercial department for any additional information or request related to our products. The information in this configurator may not be considered a sale offer or other type of contract or agreement with ISTOBAL, SA or with the entities belonging to its group. In case that users would like to purchase an ISTOBAL product with the characteristics and equipment indicated in the configuration, they can contact the ISTOBAL S.A. Commercial Network. who will inform them about  the final details of the product. ISTOBAL SA . does not guarantee that the specific configuration chosen by the User is totally or partially available.",
        "RightsReserved"              : "All rights reserved",
        "E-mail"                      : "E-mail",
        "E-mailPlaceholder"           : "Your E-mail",
        "DownloadPDF"                 : "Download PDF",
        "CopyLink"                    : "Copy link",
        "Help"                        : "Help",
        "NeedHelp"                    : "Need help?",
        "CallTo"                      : "Call to +1 800 336 8795",
        "CallToPhone"                 : "+18003368795",
        "ContactUsTitle"              : "Contact us, one of our specialist will get back to you very soon",
        "ContactUsIframeURL_es_en"    : "https://go.istobal.com/l/954553/2022-05-31/4nfhl",
        "ContactUsIframeURL_es_es"    : "https://go.istobal.com/l/954553/2022-05-31/4nfhp",
        "ContactUsIframeURL_int_en"    : "https://go.istobal.com/l/954553/2022-05-31/4nfhl",
        "ContactUsIframeURL_int_es"    : "https://go.istobal.com/l/954553/2022-05-31/4nfhp",
        "ContactUsIframeURL_us_es"    : "https://go.istobal.com/l/954553/2022-05-10/411s2",
        "ContactUsIframeURL_us_en_us" : "https://go.istobal.com/l/954553/2022-05-10/411s2",
        "ContactUsIframeURL_br_en"    : "https://go.istobal.com/l/954553/2022-05-31/4nfhl",
        "ContactUsIframeURL_br_pt"    : "https://go.istobal.com/l/954553/2022-05-31/4nfhp",
        "AskInformation"              : "Ask for more information",
        "Exit"                        : "Exit",
        "Close"                       : "Close",
        "ChooseAnOptionCustomRollover": "Choose an option for  your custom  rollover",
        "clipboardLink"               : "Link copied to clipboard!",
        "emailSending"                : "Sending to ... ",
        "emailSent"                   : "Sent!",
        "emailError"                  : "Ups! Something was wrong. Try again in a few minutes or download the PDF",
        "emailFormat"                 : "Enter a valid email",
        "ConfiguracionesiQuote"       : "Standard configurations:",
        "Aceptar"                     : "Agree",
        "Notice"                      : "Notice",
        "NoticeText"                  : 'Remember that iQuote allows you to configure the Rollovers with one color two colors (with four types of combinations). The rest of configurations are not included in iQuote and cannot be produced.<br /><br />Press the info icon <span data-v-16b6fa28="" class="icon is-small"><svg class="svg-inline--fa fa-info-circle fa-w-16" aria-hidden="true" data-prefix="fas" data-icon="info-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"></path></svg><!-- <i class="fas fa-info-circle"></i> --></span> for more information about the options available on each machine.',
        "ConfStandardIQuote"          : 'Standard Configurations',
        "UnColor"                     : '1A',
        "Central"                     : 'Front',
        "Posterior"                   : 'Rear'
    }

}
